<template>
  <div class="grid h-screen grid-cols-12 overflow-hidden">
    <div class="col-span-9">
      <div class="sticky top-0 z-50 flex items-center justify-between h-12 px-4 bg-white shadow-md">
        <router-link :to="{ name: 'AutomationList' }">
          <img src="../assets/img/logo-dark.svg" class="h-8">
        </router-link>
      </div>
      <router-view class="w-full h-full" />
    </div>
    <div class="col-span-3">
      <monitor-feed />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MonitorFeed from '@/views/monitor/MonitorFeed'

export default {
  name: 'Monitor',

  metaInfo () {
    const accountName = this.account.name
    return {
      title: 'Monitor',
      titleTemplate: `%s | ${accountName}`
    }
  },

  components: {
    MonitorFeed
  },

  computed: {
    ...mapGetters(['account'])
  },
  
  data () {
    return {

    }
  }
}
</script>